import React from 'react';
import { RefeFinancialTexts } from '../contexts/LangRef';

function ReferanceFinancial({ lang = 'ko' }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '48px 16px'
      }}
    >
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 700,
        color: '#fff',
        marginTop: 60,
        marginBottom: 40,
        textAlign: 'center'
      }}>
        {RefeFinancialTexts.title[lang]}
      </h1>
      {/* 금융 사례 내용을 여기에 추가하세요 */}
    </div>
  );
}

export default ReferanceFinancial;